import React from 'react';
import './LanguageSelector.css';

const LanguageSelector = ({ onLanguageSelect }) => {
  return (
    <div className="language-selector">
      <div className="language-container">
        <h1>Dice Simulation / Zar Simülasyonu</h1>
        <p>Please select your language / Lütfen dilinizi seçin</p>
        
        <div className="language-buttons">
          <button 
            className="language-btn english"
            onClick={() => onLanguageSelect('en')}
          >
            <span className="flag">🇬🇧</span>
            <span className="language-name">English</span>
          </button>
          
          <button 
            className="language-btn turkish"
            onClick={() => onLanguageSelect('tr')}
          >
            <span className="flag">🇹🇷</span>
            <span className="language-name">Türkçe</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
